import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import '../css/app.css';
import 'react-loading-skeleton/dist/skeleton.css'
import { store } from "./store/store";
import { initSentry, SentryErrorBoundary, setUserContext } from "./utils/sentry";

import Admin from '@/pages/admin/Admin';
import Client from '@/pages/client/Client';
import Terms from '@/pages/terms';
import Policy from '@/pages/policy';

// Initialize Sentry
initSentry();

const App: React.FC = () => {
  useEffect(() => {
    // Set user context when user is available
    const user = store.getState().auth.me;
    if (user?.id) {
      setUserContext(user);
    }
  }, []);

  return (
    <SentryErrorBoundary fallback={<div>Something went wrong</div>}>
      <Routes>
        {/* Define the Client route */}
        <Route path="/terms" element={<Terms />} />
        <Route path="/policy" element={<Policy />} />
        <Route path="/*" element={<Client />} />
        {/* Define the Admin route */}
        <Route path="/panel/*" element={<Admin />} />
      </Routes>
    </SentryErrorBoundary>
  );
};

export default App;